const common = require("lib/labels/_common");

// Home.backoffice.apps

module.exports = {
  appList: {
    title: {
      en: "Apps",
      fr: "Apps"
    },
    title_delete_check: common.title_delete_check,
    content_delete_check: common.content_delete_check,
    no: common.no,
    yes: common.yes,
    edit: common.edit,
    remove: {
      en: "Remove",
      fr: "Supprimer"
    },
    detailed: {
      icon: {
        en: "Icon",
        fr: "Icône"
      },
      key: {
        en: "Key",
        fr: "Mot-clé"
      },
      version: {
        en: "Version",
        fr: "Version"
      }
    }
  },
  appForm: {
    stepTitle: common.app,
    title: {
      creation: {
        en: "New app",
        fr: "Nouvelle application "
      },
      edition: {
        en: "Edit app",
        fr: "Edition d'application"
      }
    },
    name: {
      en: {
        en: "English name",
        fr: "Nom anglais"
      },
      fr: {
        en: "French name",
        fr: "Nom français"
      }
    },
    key: {
      en: "App keyword",
      fr: "clé unique de l'application"
    },
    hash: {
      en: "Hash",
      fr: "Hash"
    },
    version: {
      en: "Version",
      fr: "Version"
    },
    // description: common.description,
    preview: {
      en: "Preview picture",
      fr: "Image d'aperçu"
    }
  },
  backendForm: {
    stepTitle: {
      en: "Backend",
      fr: "Backend"
    },
    title: {
      creation: {
        en: "Backend",
        fr: "Backend"
      },
      edition: {
        en: "Edit Backend",
        fr: "Edition de Backend"
      }
    },
    backend: {
      label: {
        en: "Backend",
        fr: "Backend"
      },
      text: {
        en: "Backend required",
        fr: "Backend requis"
      }
    }
  }
};
